import { css, html, LitElement } from "lit";

import { ltErrorText } from "../lib/errors-lt";

/**
 * <modulina-status> — the single honest status strip (spec-web-ui §2:
 * registry code + human LT text). Kinds: error (code + gloss), ok, info,
 * loading. `aria-live` so screen readers announce state changes.
 */
export class ModulinaStatus extends LitElement {
  static override properties = {
    kind: {},
    text: {},
    code: {},
  };

  /** "" | "error" | "ok" | "info" | "loading" */
  declare kind: string;
  /** Free text (ok/info/loading) — for errors the LT gloss comes from the code. */
  declare text: string;
  /** Registry/client error code (errors only). */
  declare code: string;

  constructor() {
    super();
    this.kind = "";
    this.text = "";
    this.code = "";
  }

  static override styles = css`
    :host {
      display: block;
    }
    .strip {
      font-size: var(--m-fs-small);
      border-radius: var(--m-radius-small);
      padding: var(--m-space-2) var(--m-space-3);
      white-space: pre-wrap;
      word-break: break-word;
    }
    .error {
      background: var(--m-color-danger-soft);
      color: var(--m-color-danger);
    }
    .ok {
      background: var(--m-color-ok-soft);
      color: var(--m-color-ok);
    }
    .info,
    .loading {
      background: var(--m-color-accent-soft);
      color: var(--m-color-text-muted);
    }
    .code {
      opacity: 0.75;
    }
  `;

  override render() {
    if (!this.kind) return null;
    if (this.kind === "error") {
      const gloss = this.text || ltErrorText(this.code);
      return html`<div class="strip error" role="alert" aria-live="assertive">
        ${gloss}${this.code ? html` <span class="code">(kodas: ${this.code})</span>` : null}
      </div>`;
    }
    return html`<div class=${`strip ${this.kind}`} aria-live="polite">
      ${this.kind === "loading" ? html`${this.text || "Kraunama…"}` : this.text}
    </div>`;
  }
}

customElements.define("modulina-status", ModulinaStatus);
